import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { http } from "@/lib/api";

const Stat = ({ label, value, tid }) => (
  <div className="border-l-2 border-slate-900 bg-white px-5 py-4">
    <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
    <p data-testid={tid} className="mt-1 font-heading text-3xl font-bold tracking-tight text-slate-900">{value}</p>
  </div>
);

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    http.get("/admin/stats").then(({ data }) => setS(data));
  }, []);
  if (!s) return null;

  return (
    <div className="fade-up space-y-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-600">Panoramica</p>
          <h1 className="mt-1 font-heading text-3xl font-bold tracking-tight text-slate-900">Dashboard</h1>
        </div>
        <Link to="/admin/condomini?nuovo=1" data-testid="dashboard-add-condominio-button" className="inline-flex items-center gap-2 rounded-md bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-600">
          <Plus className="h-4 w-4" /> Nuovo condominio
        </Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Condomini" value={s.totale_condomini} tid="stat-condomini" />
        <Stat label="Documenti attivi" value={s.documenti_attivi} tid="stat-documenti" />
        <Stat label="Amministratori (P.IVA)" value={s.amministratori} tid="stat-amministratori" />
        <Link to="/admin/richieste" data-testid="stat-richieste-link"><Stat label="Richieste da leggere" value={s.richieste_da_leggere} tid="stat-richieste" /></Link>
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading font-semibold text-slate-900">Copertura documenti</h2>
          <div className="mt-5 space-y-4">
            {s.doc_types.map((d) => {
              const n = s.per_documento[d.tipo];
              const pct = s.totale_condomini ? Math.round((n / s.totale_condomini) * 100) : 0;
              return (
                <div key={d.tipo} data-testid={`coverage-${d.tipo}`}>
                  <div className="flex justify-between text-sm"><span className="text-slate-700">{d.titolo}</span><span className="font-mono text-slate-500">{n}/{s.totale_condomini}</span></div>
                  <div className="mt-1.5 h-1.5 rounded-full bg-slate-100"><div className="h-full rounded-full bg-blue-600 transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
                </div>
              );
            })}
          </div>
        </section>
        <section className="rounded-xl border border-slate-200 bg-white p-6">
          <h2 className="font-heading font-semibold text-slate-900">Ultimi aggiornati</h2>
          <ul className="mt-4 divide-y divide-slate-100">
            {s.recenti.map((c) => (
              <li key={c.id} className="flex items-center justify-between py-3 text-sm">
                <div><p className="font-medium text-slate-900">{c.nome}</p><p className="font-mono text-xs text-slate-500">{c.codice_fiscale}</p></div>
                <span className="text-xs text-slate-400">{new Date(c.updated_at).toLocaleDateString("it-IT")}</span>
              </li>
            ))}
            {s.recenti.length === 0 && <li className="py-3 text-sm text-slate-500">Nessun condominio inserito.</li>}
          </ul>
        </section>
      </div>
    </div>
  );
}
